import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

interface FAQItem {
  question: string;
  answer: string;
}

export const JournalAccordion: React.FC<{ items: FAQItem[]; title?: string }> = ({ items, title = "Frequently Asked Questions" }) => (
  <div className="my-12 p-8 bg-gray-50 rounded-sm border border-gray-100">
    <h3 className="text-2xl font-playfair font-bold text-gray-900 mb-6">{title}</h3>
    <Accordion type="single" collapsible className="w-full">
      {items.map((item, index) => (
        <AccordionItem key={index} value={`item-${index}`} className="border-gray-200">
          <AccordionTrigger className="text-left font-medium text-gray-900 hover:text-alpine-gold">
            {item.question}
          </AccordionTrigger>
          <AccordionContent className="text-gray-600 leading-relaxed font-light">
            {item.answer}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </div>
);
